/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { Flash } from "./modelFlash";

class ControllerFlash extends ControllerModel {
  constructor() {
    super("ControllerFlash");
    
    this.setNewNode = (callback) => {
      let flash = new Flash();
      flash.decorate(callback);

      this.addNode(flash);
    }

    this.loadNode = (node, callback) => {
      let flash = new Flash();
      flash.copyFrom(node);
      flash.decorate(callback);
      this.addNode(flash)
    }

    this.getProperties = async (node) => {
      let n = new Flash();
      await n.copyFrom(node);
      return n.data
  }

  this.getNode = (node) => {
      let n = new Flash();
      n.copyFrom(node);
      return n
  }
  }
}

export { ControllerFlash };
